export default __webpack_public_path__ + "static/media/under_construction.9dbcc30b.jpeg";